import React, { useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import DownloadAgendaPDFButton from "../DownloadAgendaPDFButton";
import Card from "../Card";
import AgendaItem from "../AgendaItem/AgendaItem";
import styles from "./AgendaListCard.module.css";

import { BlobProvider } from "@react-pdf/renderer";
import AgendaPdf from "../../AgendaPage/AgendaPdf";
import dayjs from "dayjs";
import CheckIntoMeetingButton from "../CheckIntoMeetingButton";
import { useMeetings } from "ManagementTeam/CalendarPage/useMeetings";

/**
 * Interactive component. Card that shows the list of agenda items and a link to download the meeting agenda PDF.
 */
export function AgendaListCard({
  meetingId,
  isCheckedIn,
  meetingAgendaLink,
  agendaItems,
  currentMeetingInfo,
  meetings,
  futureMeetingsForEC,
  pdfDate,
  date,
  attendanceItem = null,
  meetingType,
  currentMeetingDate,
}) {
  // error message for case of empty/undefined/null arrays
  const { meetingCheckInProxyGuestsPut } = useMeetings();
  const Error = () => {
    return <div className={styles.error}>No items on the Agenda</div>;
  };
  const toggleIsChecked = (id) => {
    setIsChecked((current) => !current);
    meetingCheckInProxyGuestsPut.mutate({
      id: id,
      proxyUsers: ["admin"],
    });
  };
  const [isChecked, setIsChecked] = useState(false);

  return (
    <div className={styles.cardContainer}>
      <Card
        header="Agenda"
        children={
          agendaItems !== null &&
          agendaItems !== undefined &&
          agendaItems.length > 0 ? (
            <div className={classNames(styles.container)}>
              <div className={styles.checkIn}>
                <CheckIntoMeetingButton
                  onClick={() => toggleIsChecked(meetingId)}
                  checkedIn={isCheckedIn || isChecked ? true : false}
                />
              </div>
              <BlobProvider
                className={styles.saveButton}
                document={
                  <AgendaPdf
                    date={date}
                    agendaItems={agendaItems}
                    futureMeetings={meetings}
                    currentMeetingInfo={currentMeetingInfo}
                    futureMeetingsForEC={futureMeetingsForEC}
                    meetingType={meetingType}
                    currentMeetingDate={currentMeetingDate}
                    isArchived={false}
                  />
                }
                fileName={`${dayjs().format("MM_DD_YYYY")} Agenda`}
              >
                {
                  ({ blob, url, loading, error }) => (
                    // loading ? (
                    //   <div className={styles.preparePdf}>Preparing PDF</div>
                    // ) : (
                    <a
                      className={styles.savePdf}
                      href={url}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <DownloadAgendaPDFButton pdfLink={""} />
                    </a>
                  )
                  // )
                }
              </BlobProvider>

              <div className={classNames(styles.items)}>
                {agendaItems.map((agendaItem, index) => {
                  return (
                    <AgendaItem
                      key={agendaItem.id}
                      {...agendaItem}
                      attendanceItem={attendanceItem}
                    />
                  );
                })}
              </div>
            </div>
          ) : (
            <Error />
          )
        }
      />
    </div>
  );
}

AgendaListCard.propTypes = {
  /**
   * Src of the agenda PDF.
   */
  meetingAgendaLink: PropTypes.string,
  /**
   * Array of AgendaItem objects.
   */
  agendaItems: PropTypes.arrayOf(
    PropTypes.shape({
      assignee: PropTypes.string,
      assignedType: PropTypes.string,
      title: PropTypes.string,
      description: PropTypes.string,
      isNew: PropTypes.bool,
      isCompleted: PropTypes.bool,
      votingStatus: PropTypes.string,
      onSaveNote: PropTypes.func,
      onDeleteNote: PropTypes.func,
      note: PropTypes.string,
      pdfName: PropTypes.string,
      onClickPdf: PropTypes.func,
    })
  ),
};
